import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import QuizModal from "../../components/quiz/AdminPart/QuizModal";
import QuizTable from "../../components/quiz/AdminPart/QuizTable";
import Error from "../../components/ui/Error";
import Modal from "../../components/ui/Modal/Modal";
import NotFound from "../../components/ui/NotFound";
import { usePageTitle } from "../../hooks/usePageTitle";
import TableLoader from "../../Loader/admin/TableLoader";
import { EditDone } from "../../redux/features/Edit/EditSlice";
import { useGetQuizzesForAdminQuery } from "../../redux/features/quiz/quizApi";

export default function Quizzes() {
  usePageTitle(`Quizzes`);
  const dispatch = useDispatch();
  const [isModal, setModal] = useState(false);
  const isEdit = useSelector((state) => state.edit?.isEdit)
  const { data: quizzes, isLoading, isError } = useGetQuizzesForAdminQuery()

  //  decide what to render
  let content = null;
  if (isLoading) { content = <TableLoader /> }
  else if (!isLoading && isError) { content = <Error isPadding={true} /> }
  else if (!isLoading && !isError && !quizzes?.length) {
    content = <NotFound isPadding={true} />
  }
  else if (!isLoading && !isError && quizzes?.length) {
    content = <QuizTable quizzes={quizzes} />
  }

  const handleOut = () => {
    setModal(false)
    dispatch(EditDone())
  }
  return (<>
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-full px-5 lg:px-20">
        <div className="px-3 py-20 bg-opacity-10">
          <div className="w-full flex">
            <button onClick={() => setModal(true)} className="btn ml-auto">Add Quiz</button>
          </div>
          <div className="overflow-x-auto mt-4">
            {content}
          </div>
        </div>
      </div>
    </section>
    {
      (isModal || isEdit) &&
      <Modal handleOut={handleOut} width={"w-[400px] lg:w-[800px] xl:w-[1000px]"}>
        <QuizModal handleOut={handleOut} />
      </Modal>
    }
  </>
  )
};